<template>
  <div class="base-button-event">
    <a
      v-if="btIconType === true"
      @click.prevent="buttonEvent(valueGroup)"
      :class="btCss"
      :id="btId"
      class="button-event-icon"
      :title="btText"
    >
      <slot name="icon" class="aa"></slot>
    </a>
    <button v-else @click="buttonEvent(valueGroup)" :class="btCss" :id="btId">
      {{ btText }}
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Vue from 'vue';
import Timer from "@/components/fragment/timer/Timer.vue";
import Swal from 'sweetalert2';
import './styles.css';

import jwt from "jsonwebtoken";

export default {
  name: "BaseButtonEvent",
  data() {
    return {
      isDisabled: false,
      minuteTimer: 0,
      timerContainer: null,
    };
  },
  props: {
    btText: {
      type: String,
      required: true,
    },
    nameAlert: {
      type: String,
      required: false,
      default: "",
    },
    prefixAlert: {
      type: String,
      required: false,
      default: "",
    },
    typeAlert: {
      type: String,
      required: false,
      default: "",
    },
    dependentAlert: {
      type: String,
      required: false,
      default: "",
    },
    listAlert: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    deactivatedAt: {
      type: String,
      required: false,
      default: ""
    },
    btIconType: {
      type: Boolean,
      default: false,
      validator: function (value) {
        return [true, false].indexOf(value) !== -1;
      },
    },
    btUrlGo: {
      type: String,
      default: "",
    },
    btUrlGoBack: {
      type: String,
      default: "",
    },
    btCss: String,
    btId: {
      type: String,
      required: true,
    },
    btClickValue: [String, Array, Object],
    btClickType: {
      type: String,
      validator: function (value) {
        return (
          [
            "alert",
            "sendPost",
            "sendPut",
            "sendDelete",
            "sendActivate",
            "goBack",
            "sendDeleteWarning",
            "sendDeleteGeneralWarning",
            "sendActivateCrudWarning",
          ].indexOf(value) !== -1
        );
      },
    },
    btRefreshParentContent: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    ...mapGetters(["headersCrud", "axiosHeaders1"]),
    valueGroup() {
      let valueGp = {
        type: this.btClickType,
        value: this.btClickValue,
        urlGo: this.btUrlGo,
        urlBack: this.btUrlGoBack,
      };

      return valueGp;
    },
  },
  methods: {
    ...mapActions("ModuleErrors", ["changeErrors"]),
    ...mapActions("ModuleLoader", ["pendingRequest", "doneRequest"]),
    deleteCrud(gp){
      this.pendingRequest();
        axios
          .put(
            gp.urlGo,
            {},
            {
              headers:
                gp.urlGo.includes("checklists") ||
                gp.urlGo.includes("itineraries")
                  ? this.axiosHeaders1
                  : this.headersCrud
            }
          )
          .then(response => {
            if (this.btRefreshParentContent === true) {
              setTimeout(() => {
                this.doneRequest();
                this.$emit("refresh-parent-content", true);
              }, 2300);
            } else {
              if (gp.urlBack !== "") {
                setTimeout(() => {
                  this.doneRequest();
                  this.$router.push({ name: gp.urlBack });
                }, 2300);
              }
            }
          })
          .catch(e => {
            if (e.response.status && e.response.status === 401) {
              this.logoutUser();
            } else {
              console.log(e);
              if (e.response.data.error) this.changeErrors([e.response.data]);
              else this.changeErrors(e.response.data);
            }
            this.doneRequest();
          });
    },
    activateCrud(gp) {
      this.pendingRequest();
        axios
          .put(
            gp.urlGo,
            {},
            {
              headers:
                gp.urlGo.includes("checklists") ||
                gp.urlGo.includes("itineraries")
                  ? this.axiosHeaders1
                  : this.headersCrud,
            }
          )
          .then((response) => {
            if (this.btRefreshParentContent === true) {
              setTimeout(() => {
                this.doneRequest();
                this.$emit("refresh-parent-content", true);
              }, 2300);
            } else {
              if (gp.urlBack !== "") {
                setTimeout(() => {
                  this.doneRequest();
                  this.$router.push({ name: gp.urlBack });
                }, 2300);
              }
            }
          })
          .catch((e) => {
            if (e.response.status && e.response.status === 401) {
              this.logoutUser();
            } else {
              console.log(e);
              if (e.response.data.error) this.changeErrors([e.response.data]);
              else this.changeErrors(e.response.data);
            }
            this.doneRequest();
          });
    },
    handleTimerComplete() {
      isDisabled.value = false;
    },
    createTimerComponent() {
      new Vue({
        render: (h) =>
          h(Timer, { props: { time: this.minuteTimer * 60, onComplete: this.handleTimerComplete } }),
      }).$mount('#timer-container');
    },
    disableButtonTimer() {
      const initToday = new Date();
      const deactivatedAtConvert = this.deactivatedAt ? new Date(this.deactivatedAt) : null;
      if (deactivatedAtConvert) {
        const differenceInMinutes = Math.floor(
          (initToday.getTime() - deactivatedAtConvert.getTime()) / (1000 * 60)
        );
        if (differenceInMinutes >= 10) {
          this.isDisabled = false;
        } else {
          this.isDisabled = true;
          this.minuteTimer = 10 - differenceInMinutes;
        }
      } else {
        this.isDisabled = false;
      }
    },
    buttonEvent(gp) {
      if (gp.type === "sendPost") {
        axios
          .post(gp.urlGo, gp.value, {
            headers: this.axiosHeaders1,
          })
          .then((response) => {
            if (gp.urlBack !== "") {
              this.$router.push({ name: gp.urlBack });
            }
          })
          .catch((e) => {
            if (e.response.status && e.response.status === 401) {
              this.logoutUser();
            } else {
              console.log(e.response.data);
              this.changeErrors(e.response.data.error);
            }
          });
      }
      if (gp.type === "sendPostCrud") {
        this.pendingRequest();
        axios
          .post(gp.urlGo, gp.value, {
            headers: this.headersCrud,
          })
          .then((response) => {
            if (gp.urlBack !== "") {
              setTimeout(() => {
                this.$router.push({ name: gp.urlBack });
                this.doneRequest();
              }, 2300);
            }
          })
          .catch((e) => {
            if (e.response.status && e.response.status === 401) {
              this.logoutUser();
            } else {
              if (e.response.data.error) this.changeErrors([e.response.data]);
              else this.changeErrors(e.response.data);
            }
            this.doneRequest();
          });
      }
      if (gp.type === "sendPostCrudUser") {
        this.pendingRequest();
        const userSettings = {
          email: gp.value.email,
          identifier: gp.value.identifier,
          locale: gp.value.locale,
          name: gp.value.name,
          password: gp.value.password,
          phone: gp.value.phone,
          role: gp.value.role,
        };
        axios
          .post(gp.urlGo, userSettings, {
            headers: this.headersCrud,
          })
          .then((response) => {
            if (response.data) {
              if (gp.value.userNotification) {
                const userNotification = {
                  userUUID: response.data.uuid,
                  companyUUID: this.getCurrentCompanyByToken(
                    this.headersCrud.Authorization
                  ),
                  userNotification: gp.value.userNotification,
                };
                axios
                  .post(
                    process.env.VUE_APP_USERS_NOTIFICATION,
                    userNotification,
                    {
                      headers: this.axiosHeaders1,
                    }
                  )
                  .then(() => {
                    if (gp.urlBack !== "") {
                      setTimeout(() => {
                        this.doneRequest();
                        this.$router.push({ name: gp.urlBack });
                      }, 2300);
                    }
                  });
              } else {
                if (gp.urlBack !== "") {
                  setTimeout(() => {
                    this.doneRequest();
                    this.$router.push({ name: gp.urlBack });
                  }, 2300);
                }
              }
            }
          })
          .catch((e) => {
            if (e.response.status && e.response.status === 401) {
              this.logoutUser();
            } else {
              if (e.response.data.error) this.changeErrors([e.response.data]);
              else this.changeErrors(e.response.data);
            }
            this.doneRequest();
          });
      }
      if (gp.type === "sendPostCrudLocation") {
        this.pendingRequest();
        let location = {
          clientUUID: gp.value.clientUUID,
          regionUUID: gp.value.regionUUID,
          cityUUID: gp.value.cityUUID,
          name: gp.value.name,
          address: gp.value.address,
          timezone: gp.value.timezone,
          latitude: gp.value.latitude,
          longitude: gp.value.longitude,
          radius: gp.value.radius,
          autoFinishRadius: gp.value.autoFinishRadius,
          geolocationAdjustment: gp.value.geolocationAdjustment,
          password: gp.value.password,
          counterPassword: gp.value.counterPassword,
          securityPhone: `${gp.value.securityPhone}`,
        };
        axios
          .post(gp.urlGo, location, {
            headers: this.headersCrud,
          })
          .then((response) => {
            setTimeout(() => {
              this.doneRequest();
              this.$router.push({ name: gp.urlBack });
            }, 2300);
            /*let urlContacts = `${process.env.VUE_APP_LOCATIONS_API}/${response.data.uuid}/contacts`;
            for (let i = 0; i < gp.value.contacts.length; i++) {
              axios
                .post(
                  urlContacts,
                  {
                    name: gp.value.contacts[i].name,
                    contact: gp.value.contacts[i].contact,
                  },
                  { headers: this.axiosHeaders1 }
                )
                .then((response) => {
                  console.log(response);
                })
                .catch((e) => {
                  this.changeErrors(e.response.data);
                });
            }
            let urlChecklists = `${process.env.VUE_APP_LOCATIONS_API}/${response.data.uuid}/checks`;
            for (let i = 0; i < gp.value.checks.length; i++) {
              axios
                .post(urlChecklists, gp.value.checks[i], {
                  headers: this.axiosHeaders1,
                })
                .then((response) => {
                  console.log(response);
                })
                .catch((e) => {
                  this.changeErrors(e.response.data);
                });
            }*/
          })
          .catch((e) => {
            if (e.response.status && e.response.status === 401) {
              this.logoutUser();
            } else {
              if (e.response.data.error) this.changeErrors([e.response.data]);
              else this.changeErrors(e.response.data);
            }
            this.doneRequest();
          });
      }
      if (gp.type === "sendPutCrudLocation") {
        let location = {
          clientUUID: gp.value.clientUUID,
          regionUUID: gp.value.regionUUID,
          cityUUID: gp.value.cityUUID,
          name: gp.value.name,
          address: gp.value.address,
          timezone: gp.value.timezone,
          latitude: gp.value.latitude,
          longitude: gp.value.longitude,
          radius: gp.value.radius,
          autoFinishRadius: gp.value.autoFinishRadius,
          geolocationAdjustment: gp.value.geolocationAdjustment,
          password: gp.value.password,
          counterPassword: gp.value.counterPassword,
          securityPhone: gp.value.securityPhone,
        };
        axios
          .put(gp.urlGo, location, {
            headers: this.headersCrud,
          })
          .then((response) => {
            setTimeout(() => {
              this.doneRequest();
              this.$router.push({ name: gp.urlBack });
            }, 2300);
          })
          .catch((e) => {
            if (e.response.status && e.response.status === 401) {
              this.logoutUser();
            } else {
              if (e.response.data.error) this.changeErrors([e.response.data]);
              else this.changeErrors(e.response.data);
            }
            this.doneRequest();
          });
      } else if (gp.type === "sendPut") {
        this.pendingRequest();
        axios
          .put(gp.urlGo, gp.value, {
            headers: this.axiosHeaders1,
          })
          .then((response) => {
            if (gp.urlBack !== "") {
              this.$router.push({ name: gp.urlBack });
            }
            this.doneRequest();
          })
          .catch((e) => {
            if (e.response.status && e.response.status === 401) {
              this.logoutUser();
            } else {
              this.changeErrors(e.response.data.error);
            }
            this.doneRequest();
          });
      } else if (gp.type === "sendPutCrud") {
        this.pendingRequest();
        axios
          .put(gp.urlGo, gp.value, {
            headers: this.headersCrud,
          })
          .then((response) => {
            if (gp.urlBack !== "") {
              setTimeout(() => {
                this.$router.push({ name: gp.urlBack });
                this.doneRequest();
              }, 2300);
            }
          })
          .catch((e) => {
            if (e.response.status && e.response.status === 401) {
              this.logoutUser();
            } else {
              if (e.response.data.error) this.changeErrors([e.response.data]);
              else this.changeErrors(e.response.data);
            }
            this.doneRequest();
          });
      } else if (gp.type === "sendPutCrudUser") {
        this.pendingRequest();
        axios
          .put(gp.urlGo, gp.value, {
            headers: this.headersCrud,
          })
          .then((response) => {
            this.doneRequest();
            if (gp.value.password) {
              this.pendingRequest();
              axios
                .put(
                  `${process.env.VUE_APP_CRUD_URL_USERS}/${response.data.uuid}/password`,
                  { password: gp.value.password },
                  { headers: this.headersCrud }
                )
                .then(() => {
                  this.doneRequest();
                  console.log("password user updated!");
                })
                .catch((e) => {
                  this.doneRequest();
                  this.changeErrors(e.response.data);
                });
            }
            const userNotification = {
              userUUID: response.data.uuid,
              companyUUID: this.getCurrentCompanyByToken(
                this.headersCrud.Authorization
              ),
              userNotification: gp.value.userNotification,
            };
            this.pendingRequest();
            axios
              .put(process.env.VUE_APP_USERS_NOTIFICATION, userNotification, {
                headers: this.axiosHeaders1,
              })
              .then(() => {
                if (gp.urlBack !== "") {
                  setTimeout(() => {
                    this.doneRequest();
                    this.$router.push({ name: gp.urlBack });
                  }, 2300);
                }
              });
            if (gp.urlBack !== "") {
              setTimeout(() => {
                this.doneRequest();
                this.$router.push({ name: gp.urlBack });
              }, 2300);
            }
          })
          .catch((e) => {
            console.log(e);
            if (e.response.status && e.response.status === 401) {
              this.logoutUser();
            } else {
              if (e.response.data.error) this.changeErrors([e.response.data]);
              else this.changeErrors(e.response.data);
            }
            this.doneRequest();
          });
      } else if (gp.type === "sendDelete") {
        this.pendingRequest();
        axios
          .put(
            gp.urlGo,
            {},
            {
              headers: this.axiosHeaders1,
            }
          )
          .then((response) => {
            if (this.btRefreshParentContent === true) {
              this.$emit("refresh-parent-content", true);
            } else {
              if (gp.urlBack !== "") {
                this.$router.push({ name: gp.urlBack });
              }
            }
            this.doneRequest();
          })
          .catch((e) => {
            if (e.response.status && e.response.status === 401) {
              this.logoutUser();
            } else {
              console.log(e);
            }
            this.doneRequest()
          });
      }else if(gp.type === "sendDeleteGeneralWarning") {
        Swal.fire({
          title: `<div class="container-tittle">Deseja desativar?</div>`,
          html: `<div class="container-alert">
          <p>Desativando, todos os locais e postos associados a ele também serão desativados.
           Obs: É possível reativá-lo e fazendo isso, todos seus locais e postos associados também serão reativados.
          </p>
          <p>Para confirmar, digite <span>desativar</span>:</p>
          </div>
          `,
          input: 'text',
          icon: 'warning',
          iconColor: '#E94C3D',
          inputAttributes: {
            autocapitalize: 'off'
          },
          showCancelButton: true,
          confirmButtonText: 'Look up',
          showLoaderOnConfirm: true,
          didOpen: function (){
             Swal.getConfirmButton().hidden=true;
             Swal.getInput().addEventListener('keyup', function(e) {
              if(e.target.value.toLowerCase() === 'desativar') {
                Swal.getConfirmButton().hidden=false;
              } else {
                Swal.getConfirmButton().hidden=true;
              }
              })
           },
          confirmButtonText: 'Look up',
          customClass: {
            actions: 'my-actions',
            cancelButton: 'order-1 cancel',
            confirmButton: 'order-2 confirm',
            input: 'input-class'
          },
          allowOutsideClick: () => !Swal.isLoading(),
          confirmButtonColor: '#E94C3D',
          confirmButtonText: 'Desativar',
          cancelButtonText: 'Cancelar',
        }).then((result) => {
          if (result.isConfirmed) {
            this.deleteCrud(gp)
          }
        });
      } else if(gp.type === "sendDeleteWarning") {
          Swal.fire({
          title: `<div class="container-tittle">Desativar ${this.typeAlert}?</div>`,
          html: `<div class="container-alert">
          <p>Essa ação irá desativar ${this.prefixAlert} ${this.typeAlert} <span>${this.nameAlert}</span>.
          Desativando ${this.prefixAlert} ${this.typeAlert}, todos os ${this.dependentAlert} a seguir também serão desativados:</p>
          <div class="container-list">
            <ul>
             ${ this.listAlert && this.listAlert.length > 0 ? this.listAlert.reduce((a,c) => `${a}<li>${c}</li>`):
             `Este ${this.typeAlert} não possui ${this.dependentAlert}`}
            </ul>
          </div>
          <p>É possível reativar ${this.prefixAlert} ${this.typeAlert} nesse caso, todos os seus ${this.dependentAlert} acima também serão reativados.</p>
          <p>Para confirmar, digite <span>desativar</span>:</p>
          </div>
          `,
          input: 'text',
          icon: 'warning',
          iconColor: '#E94C3D',
          inputAttributes: {
            autocapitalize: 'off'
          },
          showCancelButton: true,
          confirmButtonText: 'Look up',
          showLoaderOnConfirm: true,
          didOpen: function (){
             Swal.getConfirmButton().hidden=true;
             Swal.getInput().addEventListener('keyup', function(e) {
              if(e.target.value.toLowerCase() === 'desativar') {
                Swal.getConfirmButton().hidden=false;
              } else {
                Swal.getConfirmButton().hidden=true;
              }
              })
           },
          confirmButtonText: 'Look up',
          customClass: {
            actions: 'my-actions',
            cancelButton: 'order-1 cancel',
            confirmButton: 'order-2 confirm',
            input: 'input-class'
          },
          allowOutsideClick: () => !Swal.isLoading(),
          confirmButtonColor: '#E94C3D',
          confirmButtonText: 'Desativar',
          cancelButtonText: 'Cancelar',
        }).then((result) => {
          if (result.isConfirmed) {
            this.deleteCrud(gp)
          }
        });
      } else if (gp.type === "sendDeleteCrud") {
        this.deleteCrud(gp)
      } else if (gp.type === "sendActivate") {
        this.pendingRequest();
        axios
          .put(
            gp.urlGo,
            {},
            {
              headers: this.axiosHeaders1,
            }
          )
          .then((response) => {
            if (this.btRefreshParentContent === true) {
              this.$emit("refresh-parent-content", true);
            } else {
              if (gp.urlBack !== "") {
                this.$router.push({ name: gp.urlBack });
              }
            }
            this.doneRequest();
          })
          .catch((e) => {
            if (e.response.status && e.response.status === 401) {
              this.logoutUser();
            } else {
              console.log(e);
            }
            this.doneRequest();
          });
      }else if (gp.type === "sendActivateCrudWarning") {
        this.disableButtonTimer();
        Swal.fire({
        title: `<div class="container-tittle">Deseja ativar?</div>`,
        html: `
          <div class="container-alert">
            <p>Para ativar, aguarde 10 minutos após a desativação:</p>
            <div id="timer-container"></div>
          </div>
        `,
        icon: 'warning',
        iconColor: '#E94C3D',
        showCancelButton: true,
        confirmButtonText: 'Ativar',
        cancelButtonText: 'Cancelar',
        customClass: {
          actions: 'my-actions',
          cancelButton: 'order-1 cancel',
          confirmButton: 'order-2 confirm',
          input: 'input-class',
        },
        didOpen:() => {
            this.timerContainer = document.getElementById('timer-container');
            Swal.getConfirmButton().hidden=true;
            if(this.isDisabled) {
              Swal.getConfirmButton().hidden=true;
              this.createTimerComponent()
            } else {
              Swal.getConfirmButton().hidden=false;                
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
        confirmButtonColor: '#E94C3D',
        }).then((result) => {
          if (result.isConfirmed) {
            this.activateCrud(gp);
          }
        });
      }else if (gp.type === "sendActivateCrud") {
        this.activateCrud(gp)
      } else if (gp.type === "goBack") {
        if (gp.urlBack !== "") {
          this.$router.push({ name: gp.urlBack });
        }
      } else if (gp.type === "alert") {
        alert(gp.value);
      }
    },
    getCurrentCompanyByToken(token) {
      const tokenDecoded = token.toString().split(" ");
      const decoded = jwt.decode(tokenDecoded[1]);
      return decoded["companyUUID"];
    },
  },
  filters: {},
  watch: {
    // deactivatedAt(newValue) {
    //   this.disableButtonTimer(newValue);
    // }
  },
};
</script>

<style lang="scss">
.base-button-event {
  display: inline-block;
  .button-event-icon {
    svg {
      color: $fme-color__yale-blue;
      &:hover {
        color: $fme-color__celestial-blue;
        cursor: pointer;
      }
    }
  }
}
</style>
